
import gql from 'graphql-tag';
import productPromotionFragment from '~/apollo/fragments/productPromotionFragment';
import travelTooltips from '~/apollo/queries/product/tooltips/travelTooltips';
import commonProductDetailMixins from '~/mixins/commonProductDetailMixins.js';
import productPromotionMixins from '~/mixins/productPromotionMixins.js';
import travelScenariosQuery from '~/apollo/queries/product/travelScenario.gql';
import productShortcutMixins from "~/mixins/productShortcutMixins.js";
import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';

export default {
  mixins: [commonProductDetailMixins, productPromotionMixins, productShortcutMixins, productInsuranceNameMixins],

  data() {
    return {
      travelScenarios: null,
      loading: 0,
      currentLocale: this.$normalizeLocale(this.$i18n.locale),
    };
  },
  // page component definitions
  apollo: {
    $loadingKey: 'loading',
    travelScenarios: {
      query: gql`
        ${travelScenariosQuery}
        ${productPromotionFragment}
      `,
      prefetch: true,
      variables() {
        return {
          scenario_code: this.$route.params.slug,
          locale: this.currentLocale,
        };
      },
    },
    travelTooltips: {
      query: travelTooltips,
      prefetch: true,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
      },
      update(data) {
        return this.$normalizeStrapi(data.infoTooltip.data);
      },
    },
  },
  computed: {
    test() {
      return this.getValueByKey('medical', 'medical_overseas_medical_expenses_limit');
    },
    simpleItems() {
      if (this.travelScenarios?.data[0]) {
        const item = this.travelScenarios?.data[0];

        let medicalScore = null;
        let emergencyScore = null;
        for (const element of item.attributes.travel_plan.data.attributes.travel_medical_coverages.data) {
          if (element.attributes.code === 'medical_score') {
            medicalScore = element.attributes.value;
          }

          if (element.attributes.code === 'emergency_score') {
            emergencyScore = element.attributes.value;
          }
        }

        let delayScore = null;
        let tripCancelScore = null;
        for (const element of item.attributes.travel_plan.data.attributes.travel_inconv_coverages.data) {
          if (element.attributes.code === 'delay_score') {
            delayScore = element.attributes.value;
          }

          if (element.attributes.code === 'inconvenience_cancellation_and_curtailment_score') {
            tripCancelScore = element.attributes.value;
          }
        }

        const planName = item.attributes.travel_plan.data.attributes.travel_plan_translations.data[0].attributes.name;

        // let promotionPrices = Array;
        // promotionPrices = [];

        // let discountedTenYearAvgPremium = null;
        // const age = parseInt(this.age);
        let promotions = null;
        let promotion = null;
        let promotion_last_call = null;

        // let decoderCTALink = this.$generateWhatsappCTALink(this.$t('products.travel.td_categoryName'), planName);
        // let decoderCTAText = "";

        let promotionPrice = null;

        let decoderCTALink = '';

        let hide = Boolean;
        hide = false;
        let noPopup = Boolean;
        noPopup = false;
        let mainCTA = this.getDecoderCTA(item, decoderCTALink);

        const shortcut = this.getProductShortcut(item.attributes);

        // check scenario level promo first , then plan level promotion
        if (item.attributes.product_promotions.data?.length > 0) {
          promotions = item.attributes.product_promotions.data;
        }
        if (item.attributes.travel_plan.data.attributes.product_promotions.data?.length > 0) {
          promotions = item.attributes.travel_plan.data.attributes.product_promotions.data;
        }
        if (promotions != null) {
          promotion = this.checkPromotionValid(promotions);
          promotion_last_call = this.checkPromotionLastCall(promotion);

          if (!promotion) {
            promotion = null;
          } else {
            if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
              decoderCTALink =
                promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;

              mainCTA = this.getDecoderCTA(item, decoderCTALink);
            }
            const discounts = promotion.attributes.DiscountPercentage;
            if (discounts) {
              // calculate promotion price and avg premium
              let premiumDay;
              // const dateRange = this.filter?.dateRange?this.filter?.dateRange:1;
              const dateRange = parseInt(this.simpleParams);
              if (dateRange < 10) {
                premiumDay = 'premium' + '0' + this.simpleParams;
              } else if (dateRange >= 10 && dateRange <= 31) {
                premiumDay = 'premium' + this.simpleParams;
              } else if (dateRange > 31) {
                premiumDay = 'premium31';
              }
              const originalPrice = item.attributes.travel_premiums.data[0]?.attributes[premiumDay];
              if (discounts.Year1 !== 0) promotionPrice = (originalPrice * (100 - discounts.Year1)) / 100;
            }
            const translation = promotion.attributes.product_promotion_translations?.data[0];
            hide = translation.attributes?.HideBanner;
            noPopup = translation?.attributes?.NoPopup??false;
          }
        }

        const filteredTranslations = this.getFilteredTranslations(item.attributes.travel_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
        .insurance_company_translations.data[0].attributes.localizations.data);

        return {
          // ***** OVERVIEW *****
          plan_code: item.attributes.plan_code,
          scenario_code: item.attributes.scenario_code,
          scenarioID: item.id,
          accident_score: item.attributes.travel_plan.data.attributes.accident_score,
          inconv_score: item.attributes.travel_plan.data.attributes.inconv_score,
          medical_emergency_score: item.attributes.travel_plan.data.attributes.medical_emergency_score,
          personal_property_score: item.attributes.travel_plan.data.attributes.property_score,
          overall_score: item.attributes.travel_plan.data.attributes.overall_score,
          medical_score: medicalScore,
          emergency_score: emergencyScore,
          delay_score: delayScore,
          trip_cancel_score: tripCancelScore,
          saleable: item.attributes.travel_plan.data.attributes.saleable,
          show_cta: item.attributes.show_cta,

          // // *****Medical and emergency assitance *****
          medical_coverage: item.attributes.travel_plan.data.attributes.travel_medical_coverages.data,
          // // *****Personal Property *****
          personal_property_coverage: item.attributes.travel_plan.data.attributes.travel_property_coverages.data,
          // // ****Inconv trip ****
          incov_trip_coverage: item.attributes.travel_plan.data.attributes.travel_inconv_coverages.data,
          // // ***Personal accident ****
          personal_accid_coverage: item.attributes.travel_plan.data.attributes.travel_accid_coverages.data,

          // *****TERMS****
          terms: item.attributes.travel_plan.data.attributes.travel_plan_terms.data,

          // ***** PREMIUM *****
          premium: item.attributes.travel_premiums.data[0].attributes,

          // insurer
          insurer_name_first:
            item.attributes.travel_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
              .insurance_company_translations.data[0].attributes.name,
          insurer_name_second:
            filteredTranslations[0].attributes.name,
          insurer_logo:
            item.attributes.travel_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.logo
              .data.attributes.url,
          insurer_code:
            item.attributes.travel_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.code,

          // // plan
          plan_name: planName,
          // overall_star: item.attributes.medical_plan.data.attributes.overall_star,

          // feature
          mobile_phone_protection: item.attributes.travel_plan.data.attributes.mobile_phone_protection,
          follow_up_physiotherapy: item.attributes.travel_plan.data.attributes.follow_up_physiotherapy,
          car_rental_excess: item.attributes.travel_plan.data.attributes.car_rental_excess,
          extreme_sports_medical: item.attributes.travel_plan.data.attributes.extreme_sports_medical,
          loss_of_travel_document: item.attributes.travel_plan.data.attributes.loss_of_travel_document,
          laptop_protection: item.attributes.travel_plan.data.attributes.laptop_protection,
          camera_protection: item.attributes.travel_plan.data.attributes.camera_protection,
          fradulent_use_credit_card: item.attributes.travel_plan.data.attributes.fradulent_use_credit_card,
          overseas_hospital_cash: item.attributes.travel_plan.data.attributes.overseas_hospital_cash,
          follow_up_chi_med: item.attributes.travel_plan.data.attributes.follow_up_chi_med,
          airline_company_winding_up: item.attributes.travel_plan.data.attributes.airline_company_winding_up,
          travel_agent_bankruptcy: item.attributes.travel_plan.data.attributes.travel_agent_bankruptcy,
          home_burglary: item.attributes.travel_plan.data.attributes.home_burglary,
          follow_up_chiropractor: item.attributes.travel_plan.data.attributes.follow_up_chiropractor,

          // ***** PROMOTION *****
          product_promotion: promotion,
          promotion_price: promotionPrice,
          promotion_last_call: promotion_last_call,

          scenarioId: item.id,
          main_cta: mainCTA,
          hide,
          noPopup,
          shortcut: shortcut,
        };
      }
      return null;
    },
    product() {
      if (!this.simpleItems) return null;
      const item = this.simpleItems;
      const featureArray = [];
      if (item.mobile_phone_protection) {
        featureArray.push({
          text: this.$t('products.travel.td_mobile_protection'),
          type: 'mobile',
        });
      }
      if (item.follow_up_physiotherapy) {
        featureArray.push({
          text: this.$t('products.travel.td_physio'),
          type: 'physio',
        });
      }
      if (item.car_rental_excess) {
        featureArray.push({
          text: this.$t('products.travel.td_car_rental'),
          type: 'car_rental',
        });
      }
      if (item.extreme_sports_medical) {
        featureArray.push({
          text: this.$t('products.travel.td_extreme_sports'),
          type: 'extreme_sport',
        });
      }
      if (item.loss_of_travel_document) {
        featureArray.push({
          text: this.$t('products.travel.td_loss_travel_doc'),
          type: 'loss_travel_doc',
        });
      }

      let premiumDay;
      const duration = parseInt(this.simpleParams);
      if (duration < 10) {
        premiumDay = 'premium' + '0' + this.simpleParams;
      } else if (duration >= 10 && duration <= 31) {
        premiumDay = 'premium' + this.simpleParams;
      } else if (duration > 31) {
        premiumDay = 'premium31';
      }
      if (!item) return null;

      return {
        highlightSection: {
          scenarioCode: item.scenario_code,
          scenarioId: item.scenarioID,
          showFiveStarBadge: this.$formatShowFiveStarBadge(item.overall_star),
          productName: item.plan_name,
          insuranceCompany: {
            name: item.insurer_name_first + ' | ' + item.insurer_name_second,
            code: item.insurer_code,
            logoSrc: item.insurer_logo,
            logoAlt: item.insurer_name_first,
          },
          userRating: {
            score: item.overall_star,
            numberOfRatedUser: '0',
          },
          tenlifeScore: {
            score: parseFloat(this.getScore(item)),
            description: this.$t('products.travel.td_overall_score'),
            toolTipHtml: this.getTooltipContentByKey('tr_overallScore'),
          },
          features: featureArray,
          keyItems: [
            {
              value: this.$formatScore(parseFloat(item.medical_emergency_score)) + ' / 10',
              key: this.$t('products.travel.td_medical_emergency_score'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('tr_medicalEmergencyScore'),
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.$formatScore(parseFloat(item.accident_score)) + ' / 10',
              key: this.$t('products.travel.td_accident_score'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('tr_accidentScore'),
              symbolValue: this.$formatSymbol(item.medical_inflation_protection),
              originalValue: '',
            },
            {
              value: this.$formatScore(parseFloat(item.inconv_score)) + ' / 10',
              key: this.$t('products.travel.td_inconv_score'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('tr_inconvenienceScore'),
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.$formatScore(parseFloat(item.personal_property_score)) + ' / 10',
              key: this.$t('products.travel.td_property_score'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('tr_propertyScore'),
              symbolValue: '',
              originalValue: '',
            },
            {
              value: item.promotion_price
                ? this.$formatPrice(item?.promotion_price, 'travel')
                : item?.premium[premiumDay]
                ? this.$formatPrice(item.premium[premiumDay], 'travel')
                : '',
              // value: this.$formatPrice(premium),
              key: this.$t('products.travel.td_adult_premium'),
              topSubText: 'HKD',
              toolTipHtml: this.getTooltipContentByKey('tr_adult'),
              symbolValue: '',
              originalValue: item.promotion_price
                ? item?.premium[premiumDay]
                  ? this.$formatPrice(item.premium[premiumDay], 'travel')
                  : ''
                : '',
            },
          ],

          mainButtonCTA: item.main_cta,
          showShortcut: this.simpleItems.shortcut,
        },
        detailSection: {
          details: [
            {
              id: 0,
              sectionTitle: this.$t('products.travel.td_overview'),
              keyValues: [
                {
                  key: this.$t('products.travel.td_overall_score'),
                  value: parseFloat(this.getScore(item)) + ' / 10',
                  keyToolTipHtml: this.getTooltipContentByKey('tr_overallScore'),
                  expandableKeyValues: [
                    // {
                    //   key: this.$t("products.travel.td_subscore_detail"),
                    //   value: "",
                    //   // value:
                    //   //   item.currency +
                    //   //   " " +
                    //   //   parseInt(coverage?.attributes.estimated_total.toFixed(0)).toLocaleString("en-US"),
                    // },
                  ],
                },
                {
                  key: this.$t('products.travel.td_medical_emergency_score'),
                  value: this.$formatScore(parseFloat(item.medical_emergency_score)) + ' / 10',
                  keyToolTipHtml: this.getTooltipContentByKey('tr_medicalEmergencyScore'),
                  expandableKeyValues: [
                    {
                      key: this.$t('products.travel.td_medical_score'),
                      value: this.$formatScore(parseFloat(item.medical_score)) + ' / 10',
                    },
                    {
                      key: this.$t('products.travel.td_emergency_score'),
                      value: this.$formatScore(parseFloat(item.emergency_score)) + ' / 10',
                    },
                  ],
                },
                {
                  key: this.$t('products.travel.td_property_score'),
                  value: this.$formatScore(parseFloat(item.personal_property_score)) + ' / 10',
                  keyToolTipHtml: this.getTooltipContentByKey('tr_propertyScore'),
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.travel.td_inconv_score'),
                  value: this.$formatScore(parseFloat(item.inconv_score)) + ' / 10',
                  keyToolTipHtml: this.getTooltipContentByKey('tr_inconvenienceScore'),
                  expandableKeyValues: [
                    {
                      key: this.$t('products.travel.td_delay_score'),
                      value: this.$formatScore(parseFloat(item.delay_score)) + ' / 10',
                    },
                    {
                      key: this.$t('products.travel.td_trip_cancel_score'),
                      value: this.$formatScore(parseFloat(item.trip_cancel_score)) + ' / 10',
                    },
                  ],
                },
                {
                  key: this.$t('products.travel.td_accident_score'),
                  value: this.$formatScore(parseFloat(item.accident_score)) + ' / 10',
                  keyToolTipHtml: this.getTooltipContentByKey('tr_accidentScore'),
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.travel.td_product_feature'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.$t('products.travel.td_mobile_protection'),
                      value: this.$formatSymbol(item.mobile_phone_protection),
                    },
                    {
                      key: this.$t('products.travel.td_laptop_protection'),
                      value: this.$formatSymbol(item.laptop_protection),
                    },
                    {
                      key: this.$t('products.travel.td_camera_protection'),
                      value: this.$formatSymbol(item.camera_protection),
                    },
                    {
                      key: this.$t('products.travel.td_credit_card'),
                      value: this.$formatSymbol(item.fradulent_use_credit_card),
                    },
                    {
                      key: this.$t('products.travel.td_car_rental'),
                      value: this.$formatSymbol(item.car_rental_excess),
                    },
                    {
                      key: this.$t('products.travel.td_extreme_sports'),
                      value: this.$formatSymbol(item.extreme_sports_medical),
                    },
                    {
                      key: this.$t('products.travel.td_oversea_hospital'),
                      value: this.$formatSymbol(item.overseas_hospital_cash),
                    },
                    {
                      key: this.$t('products.travel.td_physio'),
                      value: this.$formatSymbol(item.follow_up_physiotherapy),
                    },
                    {
                      key: this.$t('products.travel.td_chinese_med'),
                      value: this.$formatSymbol(item.follow_up_chi_med),
                    },
                    {
                      key: this.$t('products.travel.td_chiro'),
                      value: this.$formatSymbol(item.follow_up_chiropractor),
                    },
                    {
                      key: this.$t('products.travel.td_addition_loss_of_travel_doc'),
                      value: this.$formatSymbol(item.loss_of_travel_document),
                    },
                    {
                      key: this.$t('products.travel.td_airline_cancel'),
                      value: this.$formatSymbol(item.airline_company_winding_up),
                    },
                    {
                      key: this.$t('products.travel.td_agent_bankrupt'),
                      value: this.$formatSymbol(item.travel_agent_bankruptcy),
                    },
                    {
                      key: this.$t('products.travel.td_home_burglary'),
                      value: this.$formatSymbol(item.home_burglary),
                    },
                  ],
                },
                {
                  key: this.simpleParams + ' ' + this.$t('products.travel.td_detail_adult_premium'),
                  value:
                    'HKD' +
                    ' ' +
                    (item.promotion_price
                      ? this.$formatPrice(item?.promotion_price, 'travel')
                      : item?.premium[premiumDay]
                      ? this.$formatPrice(item.premium[premiumDay], 'travel')
                      : ''),
                  keyToolTipHtml: this.getTooltipContentByKey('tr_adult'),
                  expandableKeyValues: [],
                  originalValue: item.promotion_price
                    ? 'HKD' + ' ' + (item?.premium[premiumDay] ? this.$formatPrice(item.premium[premiumDay], 'travel') : '')
                    : '',
                },
              ],
            },
            {
              id: 1,
              sectionTitle: this.$t('products.travel.td_section_medical_emergency'),
              keyValues: [
                {
                  key: this.getDescriptionByKey('medical', 'medical_emergency_score'),
                  value: this.$formatScore(this.getValueByKey('medical', 'medical_emergency_score')) + ' / 10',
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('medical', 'medical_score'),
                  value: this.$formatScore(this.getValueByKey('medical', 'medical_score')) + ' / 10',
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('medical', 'medical_overseas_medical_expenses_limit'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(
                      this.$formatScore(this.getValueByKey('medical', 'medical_overseas_medical_expenses_limit'))
                    ).toLocaleString('en-US'),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('medical', 'medical_follow_up_medical_accident_limit'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(
                      this.getValueByKey('medical', 'medical_follow_up_medical_accident_limit').toFixed(0)
                    ).toLocaleString('en-US'),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('medical', 'medical_follow_up_medical_illness_limit'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(
                      this.getValueByKey('medical', 'medical_follow_up_medical_illness_limit').toFixed(0)
                    ).toLocaleString('en-US'),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.$t('products.travel.td_detail_chinese_med'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.getDescriptionByKey('medical', 'medical_follow_up_chinese_practitioner_limit'),
                      value:
                        'HKD' +
                        ' ' +
                        parseInt(
                          this.getValueByKey('medical', 'medical_follow_up_chinese_practitioner_limit').toFixed(0)
                        ).toLocaleString('en-US'),
                    },
                    {
                      key: this.getDescriptionByKey('medical', 'medical_follow_up_chinese_practitioner_per_day_limit'),
                      value:
                        'HKD' +
                        ' ' +
                        parseInt(
                          this.getValueByKey('medical', 'medical_follow_up_chinese_practitioner_per_day_limit').toFixed(
                            0
                          )
                        ).toLocaleString('en-US'),
                    },
                  ],
                },
                {
                  key: this.$t('products.travel.td_detail_chiro'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.getDescriptionByKey('medical', 'medical_follow_up_chiropractor_limit'),
                      value:
                        'HKD' +
                        ' ' +
                        parseInt(
                          this.getValueByKey('medical', 'medical_follow_up_chiropractor_limit').toFixed(0)
                        ).toLocaleString('en-US'),
                    },
                    {
                      key: this.getDescriptionByKey('medical', 'medical_follow_up_chiropractor_per_day_limit'),
                      value:
                        'HKD' +
                        ' ' +
                        parseInt(
                          this.getValueByKey('medical', 'medical_follow_up_chiropractor_per_day_limit').toFixed(0)
                        ).toLocaleString('en-US'),
                    },
                  ],
                },
                {
                  key: this.$t('products.travel.td_detail_physio'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.getDescriptionByKey('medical', 'medical_follow_up_physiotherapy_limit'),
                      value:
                        'HKD' +
                        ' ' +
                        parseInt(this.getValueByKey('medical', 'medical_follow_up_physiotherapy_limit')
                          .toFixed(0))
                          .toLocaleString('en-US'),
                    },
                    {
                      key: this.getDescriptionByKey('medical', 'medical_follow_up_physiotherapy_per_day_limit'),
                      value:
                        'HKD' +
                        ' ' +
                        parseInt(this.getValueByKey('medical', 'medical_follow_up_physiotherapy_per_day_limit')
                          .toFixed(0))
                          .toLocaleString('en-US'),
                    },
                  ],
                },
                {
                  key: this.$t('products.travel.td_detail_oversea_hos_cash'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.getDescriptionByKey('medical', 'medical_overseas_hospital_cash'),
                      value:
                        'HKD' +
                        ' ' +
                        parseInt(this.getValueByKey('medical', 'medical_overseas_hospital_cash', false)
                            .toFixed(0))
                            .toLocaleString('en-US'),
                    },
                    {
                      key: this.getDescriptionByKey('medical', 'medical_overseas_hospital_cash_day_limit'),
                      value:
                        this.getValueByKey('medical', 'medical_overseas_hospital_cash_day_limit')
                        + ' '
                        + this.$t('products.travel.td_dayUnit')
                    },
                    {
                      key: this.getDescriptionByKey('medical', 'medical_overseas_hospital_cash_per_day_limit'),
                      value:
                        'HKD' +
                        ' ' +
                        parseInt(this.getValueByKey('medical', 'medical_overseas_hospital_cash_per_day_limit')
                          .toFixed(0))
                          .toLocaleString('en-US'),
                    },
                  ],
                },
                {
                  key: this.getDescriptionByKey('medical', 'emergency_score'),
                  value: this.$formatScore(this.getValueByKey('medical', 'emergency_score')) + ' / 10',
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('medical', 'emergency_medical_evacuation_limit'),
                  value:
                    this.getValueByKey('medical', 'emergency_medical_evacuation_limit')
                      .toFixed(0)
                      .toLocaleString('en-US') === '-1'
                      ? this.$t('products.travel.td_unlimited')
                      : 'HKD' +
                        ' ' +
                        parseInt(this.getValueByKey('medical', 'emergency_medical_evacuation_limit')
                          .toFixed(0))
                          .toLocaleString('en-US'),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('medical', 'emergency_repatriation_limit'),
                  value:
                    this.getValueByKey('medical', 'emergency_repatriation_limit').toFixed(0).toLocaleString('en-US') ===
                    '-1'
                      ? this.$t('products.travel.td_unlimited')
                      : 'HKD' +
                        ' ' +
                        parseInt(this.getValueByKey('medical', 'emergency_repatriation_limit')
                          .toFixed(0))
                          .toLocaleString('en-US'),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.$t('products.travel.td_detail_compassionate_visit'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.getDescriptionByKey('medical', 'emergency_compassionate_visit_limit'),
                      value:
                        this.getValueByKey('medical', 'emergency_compassionate_visit_limit')
                          .toFixed(0)
                          .toLocaleString('en-US') === '-1'
                          ? this.$t('products.travel.td_not_specified')
                          : 'HKD' +
                            ' ' +
                            parseInt(this.getValueByKey('medical', 'emergency_compassionate_visit_limit')
                              .toFixed(0))
                              .toLocaleString('en-US'),
                    },
                    {
                      key: this.$t('products.travel.td_term_term'),
                      value: this.getTermsByCode('emergency_compassionate_visit_terms'),
                    },
                  ],
                },
                {
                  key: this.$t('products.travel.td_detail_return_unattend_child'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.getDescriptionByKey('medical', 'emergency_child_escort_limit'),
                      value:
                        this.getValueByKey('medical', 'emergency_child_escort_limit')
                          .toFixed(0)
                          .toLocaleString('en-US') === '-1'
                          ? this.$t('products.travel.td_not_specified')
                          : 'HKD' +
                            ' ' +
                            parseInt(this.getValueByKey('medical', 'emergency_child_escort_limit')
                              .toFixed(0))
                              .toLocaleString('en-US'),
                    },
                    // term
                    {
                      key: this.$t('products.travel.td_term_term'),
                      value: this.getTermsByCode('emergency_child_escort_terms'),
                    },
                  ],
                },
                {
                  key: this.getDescriptionByKey('medical', 'emergency_compassionate_death_benefit_accident'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(
                      this.getValueByKey('medical', 'emergency_compassionate_death_benefit_accident').toFixed(0)
                    ).toLocaleString('en-US'),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('medical', 'emergency_compassionate_death_benefit_sickness'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(
                      this.getValueByKey('medical', 'emergency_compassionate_death_benefit_sickness').toFixed(0)
                    ).toLocaleString('en-US'),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
              ],
            },
            {
              id: 2,
              sectionTitle: this.$t('products.travel.td_section_property'),
              keyValues: [
                {
                  key: this.getDescriptionByKey('property', 'property_score'),
                  value: this.$formatScore(this.getValueByKey('property', 'property_score')) + ' / 10',
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('property', 'personal_property_total_limit'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(this.getValueByKey('property', 'personal_property_total_limit').toFixed(0)).toLocaleString(
                      'en-US'
                    ),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('property', 'personal_property_sports_equipment_limit'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(
                      this.getValueByKey('property', 'personal_property_sports_equipment_limit').toFixed(0)
                    ).toLocaleString('en-US'),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('property', 'personal_property_mobile_phone_limit'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(
                      this.getValueByKey('property', 'personal_property_mobile_phone_limit').toFixed(0)
                    ).toLocaleString('en-US'),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.$t('products.travel.td_term_mobile'),
                  value: this.getTermsByCode('personal_property_mobile_phone_terms'),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('property', 'personal_property_laptop_computer_limit'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(
                      this.getValueByKey('property', 'personal_property_laptop_computer_limit').toFixed(0)
                    ).toLocaleString('en-US'),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.$t('products.travel.td_term_laptop'),
                  value: this.getTermsByCode('personal_property_laptop_computer_terms'),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('property', 'personal_property_camera_recorder_limit'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(
                      this.getValueByKey('property', 'personal_property_camera_recorder_limit').toFixed(0)
                    ).toLocaleString('en-US'),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('property', 'personal_property_others_limit'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(
                      this.getValueByKey('property', 'personal_property_others_limit').toFixed(0)
                    ).toLocaleString('en-US'),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('property', 'personal_property_excess'),
                  value: this.$formatPercentageDP(this.getValueByKey('property', 'personal_property_excess'), 0),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('property', 'personal_property_loss_cash_theft'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(
                      this.getValueByKey('property', 'personal_property_loss_cash_theft').toFixed(0)
                    ).toLocaleString('en-US'),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('property', 'personal_property_loss_cash_accident'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(
                      this.getValueByKey('property', 'personal_property_loss_cash_accident').toFixed(0)
                    ).toLocaleString('en-US'),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('property', 'personal_property_credit_card_protection_limit'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(
                      this.getValueByKey('property', 'personal_property_credit_card_protection_limit').toFixed(0)
                    ).toLocaleString('en-US'),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('property', 'personal_property_loss_travel_document_limit'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(
                      this.getValueByKey('property', 'personal_property_loss_travel_document_limit').toFixed(0)
                    ).toLocaleString('en-US'),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('property', 'personal_property_car_rental_excess_amount'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(
                      this.getValueByKey('property', 'personal_property_car_rental_excess_amount').toFixed(0)
                    ).toLocaleString('en-US'),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
              ],
            },
            {
              id: 3,
              sectionTitle: this.$t('products.travel.td_section_trip_inconv'),
              keyValues: [
                {
                  key: this.getDescriptionByKey('travel', 'inconvenience_score'),
                  value: this.$formatScore(this.getValueByKey('travel', 'inconvenience_score')) + ' / 10',
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('travel', 'delay_score'),
                  value: this.$formatScore(this.getValueByKey('travel', 'delay_score')) + ' / 10',
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('travel', 'delay_baggage_benefit_limit'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(this.getValueByKey('travel', 'delay_baggage_benefit_limit').toFixed(0)).toLocaleString(
                      'en-US'
                    ),
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.getDescriptionByKey('travel', 'delay_baggage_benefit_hour_req'),
                      value:
                        this.getValueByKey('travel', 'delay_baggage_benefit_hour_req') +
                        ' ' +
                        this.$t('products.travel.td_hourUnit'),
                    },
                    {
                      key: this.getDescriptionByKey('travel', 'delay_baggage_benefit_terms'),
                      value: this.getValueByKey('travel', 'delay_baggage_benefit_terms'),
                    },
                  ],
                },
                {
                  key: this.getDescriptionByKey('travel', 'delay_travel_benefit_limit'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(this.getValueByKey('travel', 'delay_travel_benefit_limit').toFixed(0)).toLocaleString(
                      'en-US'
                    ),
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.getDescriptionByKey('travel', 'delay_travel_benefit_first_tier_hour'),
                      value:
                        this.getValueByKey('travel', 'delay_travel_benefit_first_tier_hour') +
                        ' ' +
                        this.$t('products.travel.td_hourUnit'),
                    },
                    {
                      key: this.$t('products.travel.td_term_benefit'),
                      value: this.getTermsByCode('delay_travel_benefit_terms'),
                    },
                  ],
                },
                {
                  key: this.getDescriptionByKey('travel', 'delay_travel_additional_travel_and_accomodation_limit'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(
                      this.getValueByKey('travel', 'delay_travel_additional_travel_and_accomodation_limit').toFixed(0)
                    ).toLocaleString('en-US'),
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.getDescriptionByKey(
                        'travel',
                        'delay_travel_additional_travel_and_accomodation_hour_req'
                      ),
                      value:
                        this.getValueByKey('travel', 'delay_travel_additional_travel_and_accomodation_hour_req') +
                        ' ' +
                        this.$t('products.travel.td_hourUnit'),
                    },
                  ],
                },
                {
                  key: this.getDescriptionByKey('travel', 'inconvenience_cancellation_and_curtailment_score'),
                  value:
                  this.$formatScore(this.getValueByKey('travel', 'inconvenience_cancellation_and_curtailment_score')) +
                    ' / 10',
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('travel', 'inconvenience_cancellation_maximum_limit'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(
                      this.getValueByKey('travel', 'inconvenience_cancellation_maximum_limit').toFixed(0)
                    ).toLocaleString('en-US'),
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.getDescriptionByKey('travel', 'inconvenience_cancellation_peril_insured_death'),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_cancellation_peril_insured_death', true)
                      ),
                    },
                    {
                      key: this.getDescriptionByKey('travel', 'inconvenience_cancellation_peril_family_death'),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_cancellation_peril_family_death', true)
                      ),
                    },
                    {
                      key: this.getDescriptionByKey(
                        'travel',
                        'inconvenience_cancellation_peril_business_partner_death'
                      ),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_cancellation_peril_business_partner_death', true)
                      ),
                    },
                    {
                      key: this.getDescriptionByKey('travel', 'inconvenience_cancellation_peril_companion_death'),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_cancellation_peril_companion_death', true)
                      ),
                    },
                    {
                      key: this.getDescriptionByKey('travel', 'inconvenience_cancellation_peril_jury_service'),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_cancellation_peril_jury_service', true)
                      ),
                    },
                    {
                      key: this.getDescriptionByKey(
                        'travel',
                        'inconvenience_cancellation_peril_travel_agent_bankruptcy'
                      ),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_cancellation_peril_travel_agent_bankruptcy', true)
                      ),
                    },
                    {
                      key: this.getDescriptionByKey('travel', 'inconvenience_cancellation_peril_airline_closure'),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_cancellation_peril_airline_closure', true)
                      ),
                    },
                    {
                      key: this.getDescriptionByKey('travel', 'inconvenience_cancellation_peril_ota_black'),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_cancellation_peril_ota_black', true)
                      ),
                    },
                    {
                      key: this.getDescriptionByKey('travel', 'inconvenience_cancellation_peril_ota_red'),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_cancellation_peril_ota_red', true)
                      ),
                    },
                    {
                      key: this.getDescriptionByKey('travel', 'inconvenience_cancellation_peril_ota_amber'),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_cancellation_peril_ota_amber', true)
                      ),
                    },
                    {
                      key: this.getDescriptionByKey(
                        'travel',
                        'inconvenience_cancellation_peril_home_damage_catastrophe'
                      ),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_cancellation_peril_home_damage_catastrophe', true)
                      ),
                    },
                    {
                      key: this.getDescriptionByKey('travel', 'inconvenience_cancellation_peril_home_damage_burglary'),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_cancellation_peril_home_damage_burglary', true)
                      ),
                    },
                  ],
                },
                {
                  key: this.getDescriptionByKey('travel', 'inconvenience_curtailment_maximum_limit'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(
                      this.getValueByKey('travel', 'inconvenience_curtailment_maximum_limit').toFixed(0)
                    ).toLocaleString('en-US'),
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.getDescriptionByKey('travel', 'inconvenience_curtailment_peril_insured_injury'),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_curtailment_peril_insured_injury', true)
                      ),
                    },
                    {
                      key: this.getDescriptionByKey('travel', 'inconvenience_curtailment_peril_insured_death'),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_curtailment_peril_insured_death', true)
                      ),
                    },
                    {
                      key: this.getDescriptionByKey('travel', 'inconvenience_curtailment_peril_family_death'),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_curtailment_peril_family_death', true)
                      ),
                    },
                    {
                      key: this.getDescriptionByKey('travel', 'inconvenience_curtailment_peril_business_partner_death'),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_curtailment_peril_business_partner_death', true)
                      ),
                    },
                    {
                      key: this.getDescriptionByKey('travel', 'inconvenience_curtailment_peril_companion_death'),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_curtailment_peril_companion_death', true)
                      ),
                    },
                    {
                      key: this.getDescriptionByKey('travel', 'inconvenience_curtailment_peril_witness_summons'),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_curtailment_peril_witness_summons', true)
                      ),
                    },
                    {
                      key: this.getDescriptionByKey(
                        'travel',
                        'inconvenience_curtailment_peril_travel_agent_bankruptcy'
                      ),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_curtailment_peril_travel_agent_bankruptcy', true)
                      ),
                    },
                    {
                      key: this.getDescriptionByKey('travel', 'inconvenience_curtailment_peril_ota_black'),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_curtailment_peril_ota_black', true)
                      ),
                    },
                    {
                      key: this.getDescriptionByKey('travel', 'inconvenience_curtailment_peril_ota_red'),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_curtailment_peril_ota_red', true)
                      ),
                    },
                    {
                      key: this.getDescriptionByKey('travel', 'inconvenience_curtailment_peril_ota_amber'),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_curtailment_peril_ota_amber', true)
                      ),
                    },
                    {
                      key: this.getDescriptionByKey(
                        'travel',
                        'inconvenience_curtailment_peril_home_damage_catastrophe'
                      ),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_curtailment_peril_home_damage_catastrophe', true)
                      ),
                    },
                    {
                      key: this.getDescriptionByKey('travel', 'inconvenience_curtailment_peril_home_damage_burglary'),
                      value: this.$formatSymbol(
                        this.getValueByKey('travel', 'inconvenience_curtailment_peril_home_damage_burglary', true)
                      ),
                    },
                  ],
                },
              ],
            },
            {
              id: 4,
              sectionTitle: this.$t('products.travel.td_section_accident'),
              keyValues: [
                {
                  key: this.getDescriptionByKey('accident', 'accident_score'),
                  value: this.$formatScore(this.getValueByKey('accident', 'accident_score')) + ' / 10',
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('accident', 'accident_benefit_limit'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(this.getValueByKey('accident', 'accident_benefit_limit').toFixed(0)).toLocaleString(
                      'en-US'
                    ),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('accident', 'accident_common_carrier_benefit_limit'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(
                      this.getValueByKey('accident', 'accident_common_carrier_benefit_limit').toFixed(0)
                    ).toLocaleString('en-US'),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('accident', 'accident_burns_benefit_limit'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(this.getValueByKey('accident', 'accident_burns_benefit_limit').toFixed(0)).toLocaleString(
                      'en-US'
                    ),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
                {
                  key: this.getDescriptionByKey('accident', 'accident_burns_common_carrier_benefit_limit'),
                  value:
                    'HKD' +
                    ' ' +
                    parseInt(
                      this.getValueByKey('accident', 'accident_burns_common_carrier_benefit_limit').toFixed(0)
                    ).toLocaleString('en-US'),
                  keyToolTipHtml: '',
                  expandableKeyValues: '',
                },
              ],
            },
          ],
          promotion: {
            category:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes
                ?.PromotionCategory,
            title:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionTitle,
            ctaButtonLink:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonLink,
            ctaButtonText:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonText,
            promotionId: item.product_promotion?.id,
            scenarioId: item.scenarioId,
            hide: this.simpleItems.hide,
            noPopup: this.simpleItems.noPopup,
            lastCall: this.simpleItems.promotion_last_call

          },
        },
      };
    },
    simpleParams() {
      if (this.$route.query.duration) {
        return this.$route.query.duration;
      }
      return '1';
    },
  },

  methods: {
    getScore(product) {
      return product.overall_score.toFixed(1);
    },

    getTermsByCode(code) {
      return this.simpleItems.terms.find((element) => element.attributes.code === code).attributes.value;
      // return this.simpleItems.terms.find(element => element.attributes.travel_coverage_term.data.attributes.travel_coverage_term_translations.data[0].attributes.code === code)
      // .attributes.travel_coverage_term.data.attributes.travel_coverage_term_translations.data[0].attributes.description;
    },
    getDescriptionByKey(coverageName, key) {
      if (coverageName === 'medical') {
        return this.simpleItems.medical_coverage?.find((coverage) => coverage.attributes.code === key)?.attributes
          ?.travel_coverage.data.attributes?.travel_coverage_translations.data[0].attributes?.description;
      }
      if (coverageName === 'property') {
        return this.simpleItems.personal_property_coverage?.find((coverage) => coverage.attributes.code === key)
          ?.attributes?.travel_coverage.data.attributes?.travel_coverage_translations.data[0].attributes?.description;
      }
      if (coverageName === 'travel') {
        return this.simpleItems.incov_trip_coverage?.find((coverage) => coverage.attributes.code === key)?.attributes
          ?.travel_coverage.data.attributes?.travel_coverage_translations.data[0].attributes?.description;
      }
      if (coverageName === 'accident') {
        return `${
          this.simpleItems.personal_accid_coverage?.find((coverage) => coverage.attributes.code === key)?.attributes
            ?.travel_coverage.data.attributes?.travel_coverage_translations.data[0].attributes?.description
        }`;
      }
      return null;
    },
    getValueByKey(coverageName, key, symbol = false) {
      if (coverageName === 'medical') {
        const result = this.simpleItems.medical_coverage?.find((coverage) => coverage.attributes.code === key);
        if (result) {
          if (symbol) {
            return result.attributes.value;
          } else {
            return parseFloat(result.attributes.value);
          }
        }
        // return this.simpleItems.medical_coverage?.find(coverage => coverage.attributes.code === key).attributes?.value;
      }
      if (coverageName === 'property') {
        const result = this.simpleItems.personal_property_coverage?.find(
          (coverage) => coverage.attributes.code === key
        );
        if (result) {
          if (symbol) {
            return result.attributes.value;
          } else {
            return parseFloat(result.attributes.value);
          }
        }
        // return this.simpleItems.personal_property_coverage?.find(coverage => coverage.attributes.code === key).attributes?.value;
      }
      if (coverageName === 'travel') {
        const result = this.simpleItems.incov_trip_coverage?.find((coverage) => coverage.attributes.code === key);
        if (result) {
          if (symbol) {
            return result.attributes.value;
          } else {
            return parseFloat(result.attributes.value);
          }
        }
        // return this.simpleItems.incov_trip_coverage?.find(coverage => coverage.attributes.code === key).attributes?.value;
      }
      if (coverageName === 'accident') {
        const result = this.simpleItems.personal_accid_coverage?.find((coverage) => coverage.attributes.code === key);
        if (result) {
          if (symbol) {
            return result.attributes.value;
          } else {
            return parseFloat(result.attributes.value);
          }
        }
        // return this.simpleItems.personal_accid_coverage?.find(coverage => coverage.attributes.code === key).attributes?.value;
      }
      return null;
    },
    getDecoderCTA(item, promotionCTALink) {
      const planName = item.attributes.travel_plan.data.attributes.travel_plan_translations.data[0].attributes.name;
      const insurer = item.attributes.travel_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;
      const decoderCTAWhatsappLink = this.$generateWhatsappCTALink(this.$t('products.travel.td_categoryName'), insurer, planName);
      const showCTA = item.attributes.show_cta;
      const saleable = item.attributes.travel_plan.data.attributes.saleable;
      const productWebsite =
        item.attributes.travel_plan.data.attributes.travel_plan_translations.data[0].attributes.product_website;
      // console.log(planName)
      // console.log(showCTA)

      if (!showCTA) return null;

      if (saleable) {
        return {
          text: this.$t('products.purchase_now'),
          link:
            process.env.SALES_EXTERNAL_URL +
            '/' +
            (this.currentLocale === 'en' ? 'en' : 'tc') +
            '/purchase?id=' +
            item.attributes.scenario_code,
        };
      } else if (promotionCTALink) {
        return {
          text: this.$t('products.purchase_now'),
          link: promotionCTALink,
        };
      } else if (productWebsite) {
        return {
          text: this.$t('products.product_website'),
          link: productWebsite,
          type: 'product-website',
        };
      } else {
        return {
          text: '',
          link: decoderCTAWhatsappLink,
        };
      }
    },
    getTooltipContentByKey(mKey) {
      return this.travelTooltips?.Travel?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
    },
  },
};
